import { IonCard } from '@ionic/react';
import { FC } from 'react';

const NotImplemented: FC = () => {
  return (
    <div className="page-container">
      <IonCard>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h1>Not Implemented</h1>
        </div>
      </IonCard>
    </div>
  );
};

export default NotImplemented;
